/**
 * @generated SignedSource<<a537377ad3d9ba5f15a6476dad96f330>>
 * @relayHash 3a6f9a0ee1190046a596a1731f90472b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 009e4c6f2525de7cd21a82a03bf9fcd77ad71e8b4048515c94cc798de55fddcf

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalExpirationIntervalUnit = "MONTH" | "WEEK" | "YEAR" | "%future added value";
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  includeApprovalExpirationConfig: boolean;
  includeApprovalsBetaFeatures: boolean;
  includeOtherModeReviewDetails: boolean;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null;
    readonly displayProperties: {
      readonly color: string | null;
      readonly name: string | null;
    } | null;
    readonly id: string | null;
  } | null> | null;
  readonly confluence_contentApprovalsSiteSettings?: {
    readonly enabled: boolean;
  } | null;
  readonly confluence_contentApprovalsSpaceSettingConfig?: {
    readonly config: {
      readonly approvalExpirationConfig?: {
        readonly changeStatus: {
          readonly expireToContentStateId: string | null;
          readonly isEnabled: boolean;
        };
        readonly interval: {
          readonly unit: ConfluenceApprovalExpirationIntervalUnit;
          readonly value: number;
        } | null;
        readonly isEnabled: boolean;
        readonly restartApproval: boolean;
      };
      readonly disallowFirstPublish: boolean;
      readonly enforcedApprovalReviewerConfig: {
        readonly isEnabled: boolean;
        readonly reviewers: ReadonlyArray<{
          readonly principalId: string;
          readonly principalType: ConfluencePrincipalType;
          readonly user: {
            readonly displayName: string | null;
            readonly id: string | null;
            readonly isActive: boolean | null;
            readonly photos: ReadonlyArray<{
              readonly isPrimary: boolean | null;
              readonly value: string | null;
            } | null> | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }>;
    readonly success: boolean;
  } | null;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly contentVersion: number | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
      readonly isActive: boolean | null;
      readonly lastModificationDate: {
        readonly value: string;
      } | null;
      readonly modifier: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly workflowId: string | null;
      readonly workflowStatusId: string | null;
    } | null;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly creatorAaid: string | null;
      readonly dueDate?: {
        readonly value: string;
      } | null;
      readonly expiryDate?: {
        readonly value: string;
      } | null;
      readonly id: string;
      readonly reviewComment: string | null;
      readonly reviewLastModified: {
        readonly value: string;
      } | null;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null;
        readonly decisionId: string | null;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null;
        readonly reviewerId: string | null;
        readonly user: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly creator?: {
        readonly displayName: string | null;
        readonly id: string | null;
      } | null;
      readonly creatorAaid?: string | null;
      readonly id: string;
      readonly reviewComment?: string | null;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions?: ReadonlyArray<{
        readonly decisionId: string | null;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null;
        readonly reviewerId: string | null;
        readonly user: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly settings?: {
      readonly contentStateSettings: {
        readonly spaceContentStates: ReadonlyArray<{
          readonly id: string | null;
          readonly name: string;
        } | null> | null;
      };
    } | null;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null;
      };
    };
  } | null;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalExpirationConfig"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalsBetaFeatures"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOtherModeReviewDetails"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    },
    {
      "condition": "includeApprovalExpirationConfig",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SpaceSettings",
          "kind": "LinkedField",
          "name": "settings",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContentStateSettings",
              "kind": "LinkedField",
              "name": "contentStateSettings",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ContentState",
                  "kind": "LinkedField",
                  "name": "spaceContentStates",
                  "plural": true,
                  "selections": [
                    (v9/*: any*/),
                    (v10/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v12 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v13 = {
  "kind": "ScalarField",
  "name": "success"
},
v14 = {
  "kind": "ScalarField",
  "name": "message"
},
v15 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v16 = {
  "kind": "ScalarField",
  "name": "value"
},
v17 = {
  "kind": "ScalarField",
  "name": "principalType"
},
v18 = {
  "kind": "ScalarField",
  "name": "principalId"
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v21 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v22 = [
  (v9/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v16/*: any*/),
      (v21/*: any*/)
    ]
  }
],
v23 = {
  "condition": "includeApprovalsBetaFeatures",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v12/*: any*/)
      ],
      "concreteType": "ConfluenceContentApprovalsSiteSettings",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSiteSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    },
    {
      "args": [
        (v12/*: any*/),
        {
          "kind": "Literal",
          "name": "filterSelf",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSpaceSettingConfig",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "concreteType": "MutationError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v14/*: any*/)
          ]
        },
        {
          "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "disallowFirstPublish"
            },
            {
              "condition": "includeApprovalExpirationConfig",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ConfluenceApprovalExpirationConfig",
                  "kind": "LinkedField",
                  "name": "approvalExpirationConfig",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    {
                      "concreteType": "ConfluenceApprovalExpirationInterval",
                      "kind": "LinkedField",
                      "name": "interval",
                      "plural": false,
                      "selections": [
                        (v16/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "unit"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "restartApproval"
                    },
                    {
                      "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                      "kind": "LinkedField",
                      "name": "changeStatus",
                      "plural": false,
                      "selections": [
                        (v15/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "expireToContentStateId"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "ConfluenceApprovalReviewerConfig",
              "kind": "LinkedField",
              "name": "enforcedApprovalReviewerConfig",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                  "kind": "LinkedField",
                  "name": "reviewers",
                  "plural": true,
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    {
                      "concreteType": "AtlassianUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": (v22/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v24 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "status"
},
v26 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v27 = {
  "args": [
    (v12/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v28 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v29 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v30 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v31 = [
  (v12/*: any*/),
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v33 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v34 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v32/*: any*/),
        (v33/*: any*/)
      ]
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v36 = {
  "kind": "ScalarField",
  "name": "creatorAaid"
},
v37 = {
  "kind": "ScalarField",
  "name": "reviewComment"
},
v38 = {
  "kind": "ScalarField",
  "name": "decisionId"
},
v39 = {
  "kind": "ScalarField",
  "name": "reviewerId"
},
v40 = {
  "kind": "ScalarField",
  "name": "required"
},
v41 = {
  "kind": "ScalarField",
  "name": "reviewerDecisionStatus"
},
v42 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v21/*: any*/),
    (v16/*: any*/)
  ]
},
v43 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v35/*: any*/),
    {
      "condition": "includeOtherModeReviewDetails",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v36/*: any*/),
        (v37/*: any*/),
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v19/*: any*/)
          ]
        },
        {
          "concreteType": "ConfluenceReviewerDecisionInfo",
          "kind": "LinkedField",
          "name": "reviewerDecisions",
          "plural": true,
          "selections": [
            (v38/*: any*/),
            (v39/*: any*/),
            (v40/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v41/*: any*/),
            {
              "concreteType": "AtlassianUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v19/*: any*/),
                (v42/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v44 = [
  (v12/*: any*/),
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  {
    "kind": "Variable",
    "name": "fetchExpiryDate",
    "variableName": "includeApprovalExpirationConfig"
  },
  (v29/*: any*/),
  (v30/*: any*/)
],
v45 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v22/*: any*/)
},
v46 = [
  (v16/*: any*/)
],
v47 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v20/*: any*/),
    (v45/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v46/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v22/*: any*/)
    }
  ]
},
v48 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v36/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v46/*: any*/)
    },
    (v35/*: any*/),
    (v37/*: any*/),
    {
      "condition": "includeApprovalsBetaFeatures",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "dueDate",
          "plural": false,
          "selections": (v46/*: any*/)
        }
      ]
    },
    {
      "condition": "includeApprovalExpirationConfig",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "expiryDate",
          "plural": false,
          "selections": (v46/*: any*/)
        }
      ]
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v46/*: any*/)
    },
    (v45/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v39/*: any*/),
        (v40/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v41/*: any*/),
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v46/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v42/*: any*/)
          ]
        }
      ]
    }
  ]
},
v49 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v32/*: any*/),
        (v33/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v11/*: any*/),
      (v23/*: any*/),
      {
        "args": (v24/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v31/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v34/*: any*/),
          (v43/*: any*/)
        ]
      },
      {
        "args": (v44/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v34/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v11/*: any*/),
      (v23/*: any*/),
      {
        "args": (v24/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      },
      (v27/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v31/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v49/*: any*/),
          (v43/*: any*/)
        ]
      },
      {
        "args": (v44/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v49/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3a6f9a0ee1190046a596a1731f90472b",
    "id": "009e4c6f2525de7cd21a82a03bf9fcd77ad71e8b4048515c94cc798de55fddcf",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!,$includeOtherModeReviewDetails:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus,creatorAaid@include(if:$includeOtherModeReviewDetails)\n      reviewComment@include(if:$includeOtherModeReviewDetails)\n      creator@include(if:$includeOtherModeReviewDetails){id,displayName}\n      reviewerDecisions@include(if:$includeOtherModeReviewDetails){decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,user{id,displayName,photos{isPrimary,value}}}}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true,fetchExpiryDate:$includeApprovalExpirationConfig){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},expiryDate@include(if:$includeApprovalExpirationConfig){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "b629f1cf67aaa014b8d2d49727153516";

export default node;
